<template>
  <div class="content" id="people-detail">
    <h1>{{ pageTitle }}</h1>
    <div class="content-body two-columns form-wrapper">
      <div class="left">
        <div class="block"><PeopleForm :people="peopleInfo"></PeopleForm></div>
      </div>
      <div class="right">
        <div class="block">Thumbnail (building)</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { PeopleForm } from './components'
export default {
  name: 'People',
  components: {
    PeopleForm
  },
  computed: {
    ...mapGetters(['peopleInfo']),
    pageTitle () {
      return this.$t('menu.people.detail')
    },
    peopleId () {
      return _.parseInt(this.$route.params.id)
    }
  },
  data () {
    return {
      loading: false
    }
  },
  mounted () {
    this.getPeopleDetail()
  },
  methods: {
    ...mapActions(['getPeople']),
    getPeopleDetail() {
      this.loading = true
      this.getPeople(this.peopleId)
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
